export default [
  {
    path: "/telegram/room",
    name: "room",
    component: () => import("@/views/room/RoomPlatformList.vue"),
    meta: {
      action: "view",
      resource: "room",
      pageTitle: "Room Platform",
      breadcrumb: [
        {
          text: "List",
          active: true
        }
      ]
    }
  },
  {
    path: "/telegram/player-transaction",
    name: "player-transaction",
    component: () => import("@/views/PlayerTransaction/PlayerTransactionList.vue"),
    meta: {
      action: "view",
      resource: "Player-transaction",
      pageTitle: "Player Transaction",
      breadcrumb: [
        {
          text: "List",
          active: true
        }
      ]
    }
  },
  {
    path: "/telegram/player-balance",
    name: "player-balance",
    component: () => import("@/views/PlayerTransaction/PlayerBalanceList.vue"),
    meta: {
      action: "view",
      resource: "player-balance",
      pageTitle: "Player Balance",
      breadcrumb: [
        {
          text: "List",
          active: true
        }
      ]
    }
  },
]